import { SignUp } from '@clerk/clerk-react';

export function SignUpPage() {
	return (
		<div class="auth-page">
			<div class="auth-container">
				<a href="/" class="auth-logo">pxtxt</a>
				<SignUp
					routing="path"
					path="/sign-up"
					signInUrl="/sign-in"
					forceRedirectUrl="/dashboard"
				/>
			</div>

			<style>{`
				.auth-page {
					min-height: 100vh;
					display: flex;
					align-items: center;
					justify-content: center;
					padding: 2rem;
					background: var(--color-bg);
				}

				.auth-container {
					text-align: center;
				}

				.auth-logo {
					display: inline-block;
					font-family: var(--font-display);
					font-size: 1.75rem;
					font-weight: 700;
					color: var(--color-title);
					text-decoration: none;
					margin-bottom: 2rem;
					letter-spacing: -0.02em;
				}

				.auth-logo:hover {
					text-decoration: none;
				}
			`}</style>
		</div>
	);
}
